import React from 'react';
import { CreateButton, TopToolbar } from 'react-admin';

import { WithRole } from 'src/components/common';
import { UserRole } from 'src/auth/types';
import { AddCircleOutline } from '@mui/icons-material';

const ToolbarActions = () => {
    return (
        <TopToolbar>
            <WithRole roles={[UserRole.ADMIN, UserRole.SYSTEM_ADMIN, UserRole.METHODOLOGIST]}>
                <CreateButton
                    label="Додати дитину"
                    variant="contained"
                    resource="children"
                    icon={<AddCircleOutline />}
                />
            </WithRole>
        </TopToolbar>
    );
};

export default ToolbarActions;
